import React from 'react'
import { connect } from 'react-redux'

import TopBar from '../../components/Interaction/TopBar'
import {
  setSeverity,
  closeTicket,
  sendFeedback,
  sendDisagreement,
  changeSeverity,
  reopenTicket,
  approveWorkRequest,
  rejectWorkRequest
} from '../../ducks/interaction'

const TopBarContainer = ({
  profile,
  interaction,
  properties,
  ui,
  changeSeverity,
  closeTicket,
  sendFeedback,
  sendDisagreement,
  reopenTicket,
  approveWorkRequest,
  rejectWorkRequest
}) => {
  const { entities, selectedPropertyId } = properties
  const { severity, data, forceDisableCloseButton, events } = interaction
  const { feedback_required, state } = data

  const currentProperty =
    entities && selectedPropertyId
      ? entities.find((property) => property.id === selectedPropertyId)
      : null

  const isDisagreementBtnVisible = currentProperty
    ? currentProperty.needHdDisagreeButton
    : true

  const { width } = ui.sizes.app
  const showBackButton = width < 992
  const isCanApprove = profile.personRole === 'ADVANCE'
  const isWorkRequest = Boolean(
    events &&
      events.find(({ workRequest }) => {
        return workRequest && !workRequest.accepted && !workRequest.cancelled
      })
  )

  return (
    <TopBar
      severity={severity}
      showBackButton={showBackButton}
      state={state}
      feedback={feedback_required}
      changeSeverity={changeSeverity}
      closeTicket={closeTicket}
      sendFeedback={sendFeedback}
      sendDisagreement={sendDisagreement}
      reopenTicket={reopenTicket}
      forceDisableCloseButton={forceDisableCloseButton}
      approveWorkRequest={approveWorkRequest}
      isCanApprove={isCanApprove}
      isWorkRequest={isWorkRequest}
      rejectWorkRequest={rejectWorkRequest}
      isDisagreementBtnVisible={isDisagreementBtnVisible}
    />
  )
}

export default connect(
  ({ interaction, ui, profile, properties }) => ({
    interaction,
    ui,
    profile,
    properties
  }),
  {
    setSeverity,
    reopenTicket,
    closeTicket,
    sendFeedback,
    sendDisagreement,
    changeSeverity,
    approveWorkRequest,
    rejectWorkRequest
  }
)(TopBarContainer)
